"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWalletPassLabels = void 0;
const locales_1 = require("../enums/locales");
const WALLET_PASS_LABELS = {
    [locales_1.Locales.EN]: {
        event: "EVENT",
        rate: "RATE",
        guest: "GUEST",
        ticketNumber: "TICKET #",
        couponNumber: "COUPON #",
        raffle: "RAFFLE",
        sweepstakes: "SWEEPSTAKES",
        entryNumber: "ENTRY #",
        date: "DATE",
        time: "TIME",
        membership: "MEMBERSHIP",
        membershipType: "MEMBERSHIP TIER",
        issuedOn: "ISSUED ON",
        renews: "RENEWS",
        member: "MEMBER",
        campaign: "CAMPAIGN",
        memberNumber: "MEMBER #",
        monthly: "Monthly",
        yearly: "Yearly",
    },
    [locales_1.Locales.FR]: {
        event: "ÉVÉNEMENT",
        rate: "TARIF",
        guest: "INVITÉ",
        ticketNumber: "BILLET #",
        couponNumber: "COUPON #",
        raffle: "LOTERIE",
        sweepstakes: "CONCOURS",
        entryNumber: "PARTICIPATION #",
        date: "DATE",
        time: "HEURE",
        membership: "ADHÉSION",
        membershipType: "NIVEAU D'ADHÉSION",
        issuedOn: "ÉMIS LE",
        renews: "RENOUVELLEMENT",
        member: "MEMBRE",
        campaign: "CAMPAGNE",
        memberNumber: "MEMBRE #",
        monthly: "Mensuel",
        yearly: "Annuel",
    },
    [locales_1.Locales.ES]: {
        event: "EVENTO",
        rate: "TARIFA",
        guest: "INVITADO",
        ticketNumber: "BOLETO #",
        couponNumber: "CUPÓN #",
        raffle: "SORTEO",
        sweepstakes: "SORTEO PROMOCIONAL",
        entryNumber: "PARTICIPACIÓN #",
        date: "FECHA",
        time: "HORA",
        membership: "MEMBRESÍA",
        membershipType: "NIVEL DE MEMBRESÍA",
        issuedOn: "EMITIDO EL",
        renews: "RENOVACIÓN",
        member: "MIEMBRO",
        campaign: "CAMPAÑA",
        memberNumber: "MIEMBRO #",
        monthly: "Mensual",
        yearly: "Anual",
    },
    [locales_1.Locales.DE]: {
        event: "VERANSTALTUNG",
        rate: "TARIF",
        guest: "GAST",
        ticketNumber: "TICKET #",
        couponNumber: "GUTSCHEIN #",
        raffle: "VERLOSUNG",
        sweepstakes: "GEWINNSPIEL",
        entryNumber: "TEILNAHME #",
        date: "DATUM",
        time: "UHRZEIT",
        membership: "MITGLIEDSCHAFT",
        membershipType: "MITGLIEDSCHAFTSSTUFE",
        issuedOn: "AUSGESTELLT AM",
        renews: "VERLÄNGERUNG",
        member: "MITGLIED",
        campaign: "KAMPAGNE",
        memberNumber: "MITGLIED #",
        monthly: "Monatlich",
        yearly: "Jährlich",
    },
};
const getWalletPassLabels = (locale) => WALLET_PASS_LABELS[locale] ?? WALLET_PASS_LABELS[locales_1.Locales.EN];
exports.getWalletPassLabels = getWalletPassLabels;
